@if (objectType() === 'svg') {
  <div #svgZoomContainer class="relative h-full w-full overflow-hidden">
    <div #svgContainer class="svgContainer h-full w-full"></div>
    <div #tooltipProxy style="position: absolute; pointer-events: none; top: 0; left: 0" [pTooltip]="richTooltipTemplate" tooltipPosition="top"></div>

    <p-button
      severity="contrast"
      variant="outlined"
      iconPos="left"
      icon="pi pi-undo"
      iconPos="right"
      size="small"
      class="absolute inset-x-0 bottom-4 grid place-items-center [&_button]:bg-white"
      [label]="'global.reset' | transloco"
      [ngClass]="{ hidden: !isZoomed }"
      (onClick)="resetZoom()" />
  </div>
  <ng-template #richTooltipTemplate>
    <div class="p-1">
      <p class="text-sm">
        {{ tooltipContent }}
      </p>
    </div>
  </ng-template>
} @else if (objectType() === 'img') {
  <app-zoom-container class="imgType absolute inset-0 h-full w-full" [initialScale]="1" [minScale]="minZoom" [maxScale]="maxZoom">
    <div #imgContainer class="imgContainer h-full w-full"></div>
  </app-zoom-container>
} @else if (hasError()) {
  <div class="mt-16 rounded-lg border border-amber-500 bg-amber-50 px-4 py-2">
    <i class="pi pi-exclamation-circle mr-2"></i>
    <span>{{ 'global.noImageView' | transloco }}</span>
  </div>
}
